import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEmployeeRateForChargeEditorQueryVariables = Types.Exact<{
  userPrincipalName: Types.Scalars['String'];
  effectiveDate: Types.Scalars['LocalDate'];
}>;


export type GetEmployeeRateForChargeEditorQuery = { __typename?: 'QueryModel', employeeRates?: { __typename?: 'EmployeeRatesQueryModel', single?: { __typename?: 'EmployeeRate', rate: number } | null } | null };


export const GetEmployeeRateForChargeEditorDocument = gql`
    query GetEmployeeRateForChargeEditor($userPrincipalName: String!, $effectiveDate: LocalDate!) {
  employeeRates {
    single(userPrincipalName: $userPrincipalName, effectiveDate: $effectiveDate) {
      rate
    }
  }
}
    `;

/**
 * __useGetEmployeeRateForChargeEditorQuery__
 *
 * To run a query within a React component, call `useGetEmployeeRateForChargeEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeRateForChargeEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeRateForChargeEditorQuery({
 *   variables: {
 *      userPrincipalName: // value for 'userPrincipalName'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useGetEmployeeRateForChargeEditorQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeRateForChargeEditorQuery, GetEmployeeRateForChargeEditorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeRateForChargeEditorQuery, GetEmployeeRateForChargeEditorQueryVariables>(GetEmployeeRateForChargeEditorDocument, options);
      }
export function useGetEmployeeRateForChargeEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeRateForChargeEditorQuery, GetEmployeeRateForChargeEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeRateForChargeEditorQuery, GetEmployeeRateForChargeEditorQueryVariables>(GetEmployeeRateForChargeEditorDocument, options);
        }
export type GetEmployeeRateForChargeEditorQueryHookResult = ReturnType<typeof useGetEmployeeRateForChargeEditorQuery>;
export type GetEmployeeRateForChargeEditorLazyQueryHookResult = ReturnType<typeof useGetEmployeeRateForChargeEditorLazyQuery>;
export type GetEmployeeRateForChargeEditorQueryResult = Apollo.QueryResult<GetEmployeeRateForChargeEditorQuery, GetEmployeeRateForChargeEditorQueryVariables>;